import { WeatherMain } from "api/event";
import ClearAnimation from "./clear.svg?react";
import CloudsAnimation from "./clouds.svg?react";
import RainAnimation from "./rain.svg?react";
import SnowAnimation from "./snow.svg?react";
import ThunderstormAnimation from "./thunderstorm.svg?react";

const weatherAnimations: { [K in WeatherMain]: SvgComponent } = {
  Clear: ClearAnimation,
  Clouds: CloudsAnimation,
  Drizzle: CloudsAnimation,
  Rain: RainAnimation,
  Snow: SnowAnimation,
  Thunderstorm: ThunderstormAnimation,
  Unknown: CloudsAnimation,
};

type SvgComponent = React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined;
  }
>;

export default weatherAnimations;
